import { productionDelay } from "./productionDelay";

export const relatedResourceConfig = {
  productionDelay,
};
